// src/Pencil.tsx
import * as React from "react";
var Pencil = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size * 1.25,
    height: props.size,
    viewBox: "0 0 20 16",
    fill: props.color,
    style: props.style,
    role: props.role,
    className: props.className
  },
  /* @__PURE__ */ React.createElement("path", { d: "M11.24 6.03c.2-.2.53-.2.73 0 .2.2.2.53 0 .73l-6.7 6.68h-.71v-.72l6.68-6.69zM14.4 1c-.19 0-.4.08-.54.23l-.93.93c-.27.27-.27.72 0 .99l1.93 1.93c.27.27.72.27.99 0l.93-.93c.3-.3.3-.81 0-1.1l-1.82-1.82A.779.779 0 0 0 14.4 1zm-2.3 2.98a.706.706 0 0 0-.99 0l-7.9 7.9c-.14.13-.21.31-.21.49v2.45c0 .1.08.18.18.18h2.45c.19 0 .36-.07.5-.21l7.9-7.9c.27-.27.27-.72 0-.99L12.1 3.98z" })
);
Pencil.displayName = "Pencil";
export {
  Pencil
};
